import { render, staticRenderFns } from "./editpushbuttoneventtype.vue?vue&type=template&id=3b4f2beb&scoped=true"
import script from "./editpushbuttoneventtype.vue?vue&type=script&lang=js"
export * from "./editpushbuttoneventtype.vue?vue&type=script&lang=js"
import style0 from "./editpushbuttoneventtype.vue?vue&type=style&index=0&id=3b4f2beb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4f2beb",
  null
  
)

export default component.exports